import React, { useEffect, useState } from 'react';
import { Button, Table, PagingQuery } from 'tea-component';
import { useIntl, history, getLocale } from 'umi';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { getCountryFlag } from '@/pages/home/_config/countries';
import { TopchartTableProps } from '@/pages/intelligence/pages/_config/topchartsInterface';
import FirstRow from '@/pages/intelligence/components/TableComponents/components/FirstRow';
// import BubbleClose from '@/pages/intelligence/components/BubbleClose';
import { FollowingTableCloums } from '@/pages/intelligence/pages/Following/_config/FollowingTableCloums';
import { getRetentionMonthlySensortowerDxHoverContent } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/RetentionCloums';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import {
  GenreHeader,
  GenreRender,
} from '@/pages/intelligence/components/TableComponents/components/TableGenre';
// import { buriedBtnPoint } from '@/pages/home/utils/buriedPoint';
// import { dbiBtnLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import Databarin from '@/pages/intelligence/assets/svg/dataSource/databarin.svg';
import DatabrainBubbleTip from '@/pages/intelligence/components/TableComponents/components/FirstRow/DatabrainBubbleTip';
import TopchartTable from '@/pages/intelligence/components/TableComponents/TopchartTable';
import {
  TableCheckboxHeader,
  TableCheckboxRender,
} from '@/pages/intelligence/components/TableComponents/components/TableCheckbox';
import { getDetailGamePathCommon } from '@/pages/intelligence/utils/topchartsUtils';
// import { DetailsCloums } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/CommonCloums';
import { DETAIL_PAGE_TAB_MSG } from '@/pages/intelligence/pages/Following/_config/util';
import TableNodata from '@/pages/intelligence/pages/Following/components/TableNodata';
import { getPriceEcharts } from '@/pages/intelligence/pages/TopCharts/PCGames/_config/tableVisibleCloums';
import { getPlatformIconsImg } from '@intelligence/utils/common';
import { SumAvgRender } from '@intelligence/pages/TopCharts/_config/TableCloums/SumAvgRender';
import { LANGUAGE_CN } from '@home/_config/config';
import { formatReleaseTime } from '@home/components/NavHeader/sreachContext/utils';
import CommonColumns from '@intelligence/pages/TopCharts/_config/TableCloums/CommonCloums';
import { normalizeTableGenreSource } from '@intelligence/v3/utils/genre';
interface ActiveUsersTableProps extends TopchartTableProps {
  showFirstGuide: boolean;
  selectDataSources: string[];
  dateType: string;
  APPID: string;
  tableHeaderList: any[];
  entityType: string;
  chartSegement: string;
  onClickNodata: Function;
  sumInfo?: string;
  genreSource?: string;
}
export default function ActiveUsers(props: ActiveUsersTableProps) {
  const {
    APPID,
    showFirstGuide,
    loading,
    records = [],
    tableTotal = 0,
    pageSortAttr,
    tableSelection,
    tableSelectionAll,
    onTableSortChage,
    onTablePagingChange,
    onTableCheckGame,
    dateType,
    tableHeaderList,
    entityType,
    chartSegement,
    onClickNodata,
    sumInfo,
    genreSource,
  } = props;

  // console.log('ActiveUsersActiveUsers', records);

  const { formatMessage } = useIntl(); // 中英切换方法
  const locale = getLocale();
  const isCN = locale === LANGUAGE_CN;
  const checkIsSumAvg = (name) => {
    return name === 'sum' || name === 'avg';
  };

  const {
    tablePageIndex,
    tablePageSize,
    currentSortValue,
    currentSortMetric,
    currentRatioType,
    currentOrderSource,
  } = pageSortAttr || {};
  const defaultPageSize = 20;
  const [pageIndex, setPageIndex] = useState(tablePageIndex || 1);
  const [pageSize, setPageSize] = useState(tablePageSize || defaultPageSize);
  const [selectList, setSelectList] = useState(tableSelection);
  // const [bubbleVisible, setBubbleVisible] = useState(false);

  useEffect(() => {
    setPageIndex(tablePageIndex);
    setPageSize(tablePageSize);
  }, [tablePageIndex, tablePageSize]);

  const onPagingChange = (e: PagingQuery) => {
    setPageIndex(e.pageIndex || 1);
    setPageSize(e.pageSize || defaultPageSize);
    onTablePagingChange(e);
  };

  const onSortChage = (e: SortByItemType) => {
    onTableSortChage(e);
  };

  useEffect(() => {
    setSelectList(tableSelection);
  }, [tableSelection]);

  const getMetricCloums = () => {
    const metricCloums: any[] = [];

    const gameOwnedCloum = {
      key: 'gameOwned',
      width: 150,
      align: 'left',
      header: formatMessage({ id: 'dbi_company_game_owned' }),
      render: (cvm: any) => (
        //如果不是数字或者数字字符串，则展示 '-'
        <>{!isNaN(cvm?.game_cnt) && !isNaN(Number(cvm?.game_cnt)) ? cvm?.game_cnt : '-'}</>
      ),
    };

    const listedCloum = {
      key: 'listed',
      width: 150,
      align: 'left',
      header: formatMessage({ id: 'dbi_company_listed' }),
      render: (cvm: any) => <>{cvm?.ipo_status || '-'}</>,
    };

    const releaseTimeCloum = {
      key: 'release_time',
      header: (
        <CloumsCenter width={140} align="left">
          <div className="header-other">{formatMessage({ id: 'dbi_release_date' })}</div>
        </CloumsCenter>
      ),
      align: 'center',
      width: 140,
      render: (cvm: any) => {
        const releaseTime = formatReleaseTime(locale, {
          isSpecialReleaseTime: cvm?.is_special_release_time,
          releaseTime: cvm?.release_time,
          releaseTimeEN: cvm?.release_time_en,
          releaseTimeCN: cvm?.release_time_cn,
        });
        return (
          <CloumsCenter width={140} align="left">
            {releaseTime || '-'}
          </CloumsCenter>
        );
      },
    };
    const genreCloum = {
      key: 'genre',
      header: (
        <div className="header-other">
          <GenreHeader />
        </div>
      ),
      width: 220,
      align: 'left',
      render: (cvm: any) => {
        return <GenreRender mainGenre={cvm?.genre || '-'} subGenre={cvm?.sub_genre || '-'} />;
      },
    };
    if (entityType === 'company') {
      metricCloums.push(gameOwnedCloum, listedCloum);
    }

    tableHeaderList?.forEach((t) => {
      if (['appannie_retention', 'sensortower_retention'].includes(t.key)) {
        const retentionMetricPrefix = t?.apiSource === 'sensortower' ? 'sensortower' : 'appannie';
        t.subOptions.forEach((subItem) => {
          metricCloums.push(
            FollowingTableCloums({
              title: subItem?.title ?? subItem?.text,
              key: `${retentionMetricPrefix}_${subItem.value}`,
              icon: subItem?.icon,
              sortMetric: subItem.value,
              textContent: getRetentionMonthlySensortowerDxHoverContent(
                formatMessage,
                subItem.value,
              ),
              // sortMetricNew: subItem.valueNew || '',
              // dataSourceNew: subItem.dataSourceNew || '',
              entityType: entityType,
              dateType: dateType,
              dataSource: t?.dataSource,
              apiSource: t?.apiSource,
              currentSortValue: currentSortValue,
              currentSortKey: `${currentSortMetric}_${currentRatioType}`,
              onSortChage: onSortChage,
              width: t?.width,
              width_cn: t?.width_cn,
              renderType: t?.renderType,
              align: t?.align,
              sortIconType: t?.sortIconType,
              metricKey: subItem.value,
              // getMetricValueOfCvm: getMetricValueOfCvm,
            }),
          );
        });
      } else {
        metricCloums.push(
          FollowingTableCloums({
            title: t?.title ?? t?.text,
            key: `${t.key ?? t.value}`,
            sortMetric: t.value,
            icon: t?.icon,
            dateType: dateType,
            dataSource: t?.dataSource,
            apiSource: t?.apiSource,
            // sortMetricNew: t.valueNew || '',
            // dataSourceNew: t.dataSourceNew || '',
            entityType: entityType,
            textContent: t.textContent,
            currentSortValue: currentSortValue,
            currentSortKey: `${currentSortMetric}_${currentRatioType}`,
            onSortChage: onSortChage,
            width: t?.width,
            width_cn: t?.width_cn,
            renderType: t?.renderType,
            align: t?.align,
            sortIconType: t?.sortIconType,
            // getMetricValueOfCvm: getMetricValueOfCvm,
            metricKey: t?.metricKey || t.value,
          }),
        );
      }
    });

    if (entityType !== 'company') {
      metricCloums.push(releaseTimeCloum);
      if (entityType === 'mobile') {
        const normalizedGenreSource = normalizeTableGenreSource(genreSource);
        if (normalizedGenreSource === 'appmagic') {
          metricCloums.push(
            CommonColumns.AppMagicSuperGenreColumn({
              locale,
              formatMessage,
              isGameDetailsMode: false,
            }),
          );
          metricCloums.push(
            CommonColumns.AppMagicMajorGenreColumn({
              locale,
              formatMessage,
              isGameDetailsMode: false,
            }),
          );
        } else {
          metricCloums.push(
            CommonColumns.GenreColumn({
              locale,
              formatMessage,
              isGameDetailsMode: false,
              genreSource: normalizedGenreSource,
            }),
          );
        }
      } else {
        metricCloums.push(genreCloum);
      }
    }
    return metricCloums;
  };

  // useEffect(() => {
  //   setBubbleVisible(showFirstGuide && !loading && records.length > 0);
  // }, [showFirstGuide, loading, records.length]);

  // const onBubbleClose = () => {
  //   //表格关注提示关闭打点
  //   buriedBtnPoint(dbiBtnLogMes.topchartMobileGameActiveUserTableTip);
  //   setBubbleVisible(false);
  // };

  const getDetailGamePath = (gameId: string) => {
    const [tab = 'stats', subTab = ''] = DETAIL_PAGE_TAB_MSG[chartSegement] || [];
    return getDetailGamePathCommon({
      entityType: entityType,
      gameId: gameId,
      tab: tab,
      subTab: subTab,
    });
  };

  const onClickGame = (gameId: string) => {
    history.push(getDetailGamePath(gameId));
  };

  useEffect(() => {
    getPriceEcharts(records, dateType, 'est_price_time');
  }, [JSON.stringify(records)]);

  return (
    <>
      <TopchartTable
        className="dbi-table-sticky"
        loading={loading}
        recordKey={APPID}
        records={records}
        tableTotal={tableTotal}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onPagingChange={onPagingChange}
        nodataDom={<TableNodata onClickNodata={onClickNodata} />}
        columns={[
          // { key: 'select', header: null, width: 37, fixed: 'left' },
          {
            key: 'select',
            width: 36,
            fixed: 'left',
            header: () => {
              return (
                <TableCheckboxHeader
                  selectList={selectList}
                  tableSelectionAll={tableSelectionAll}
                  disabled={loading || records.length === 0}
                  onChange={(list, stats) => {
                    onTableCheckGame(list, stats);
                    setSelectList(list);
                  }}
                />
              );
            },
            render: (cvm: any) => {
              const isSumAvg = checkIsSumAvg(cvm?.agg_name);
              return (
                <TableCheckboxRender
                  selectList={selectList}
                  cvm={{ ...(cvm || {}), gameId: cvm?.[APPID] }}
                  disabled={isSumAvg}
                  onChange={(list, status) => {
                    setSelectList(list);
                    onTableCheckGame(list, status);
                  }}
                />
              );
            },
          },
          {
            key: 'gametitle',
            header: (
              // <BubbleClose
              //   style={{ width: '400px' }}
              //   placement="bottom-start"
              //   placementOffset={[60, -35]}
              //   content={formatMessage({ id: `dbi_first_follow_info` })}
              //   visible={bubbleVisible}
              //   onClose={onBubbleClose}
              // >
              <div className="dbi-firstRow-flex">
                <div className="dbi-text-id">#</div>
                <div>{formatMessage({ id: 'dbi_top_gametitle' })}</div>
              </div>
              // </BubbleClose>
            ),
            width: 330,
            fixed: 'left',
            render: (cvm: any) => {
              const icons = getPlatformIconsImg(cvm?.platform);
              const isSumAvg = checkIsSumAvg(cvm?.agg_name);
              return (
                <FirstRow
                  showImg={isSumAvg ? false : true}
                  id={isSumAvg ? '-' : cvm?.rank}
                  renderDom={isSumAvg ? SumAvgRender(cvm?.agg_name, sumInfo) : null}
                  cvm={{
                    img: cvm?.cover,
                    imgType: entityType,
                    gametitle: cvm?.name,
                    countryIcon: isSumAvg
                      ? ''
                      : getCountryFlag(
                          entityType === 'pc' || entityType === 'console'
                            ? cvm?.publisher_addr
                            : cvm?.markets,
                        ),
                    text:
                      entityType === 'company'
                        ? `${cvm.location_identifiers_city}\xa0\xa0${cvm.location_identifiers_country}`
                        : cvm?.publisher,
                    isDatabrain: cvm?.b_ogdb_data ? Databarin : '',
                    databrainIconTip: <DatabrainBubbleTip />,
                    icon: entityType === 'console' ? icons : null,
                  }}
                  rihgtClickToJumpHref={isSumAvg ? '' : getDetailGamePath(cvm?.[APPID])}
                  onClick={() => {
                    if (isSumAvg) return;
                    onClickGame(cvm?.[APPID]);
                  }}
                />
              );
            },
          },
          ...getMetricCloums(),
          {
            key: 'actions',
            header: formatMessage({ id: 'dbi_actions' }),
            align: 'left',
            width: 100,
            render: (cvm: any) => {
              const isSumAvg = checkIsSumAvg(cvm?.agg_name);
              if (isSumAvg) {
                return <>-</>;
              }
              return (
                <Button
                  className="table-link"
                  onClick={() => {
                    if (onClickGame instanceof Function) {
                      onClickGame(cvm?.[APPID]);
                    }
                  }}
                  type="link"
                >
                  {formatMessage({ id: 'dbi_details' })}
                </Button>
              );
            },
          },
        ]}
      />
    </>
  );
}
